import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export function Login() {
  const nav = useNavigate();
  const [devEmail, setDevEmail] = useState("");
  const [err, setErr] = useState<string | null>(null);

  return (
    <div className="space-y-6 max-w-md">
      <h1 className="text-xl font-semibold">Sign in</h1>

      <div>
        <a
          href="/auth/microsoft"
          className="inline-block px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
        >
          Sign in with Microsoft
        </a>
      </div>

      <hr />

      <div>
        <p className="text-sm text-slate-600 mb-2">
          Dev login (only available when <code>server.dev_login_enabled = true</code> in config):
        </p>
        <form
          className="flex gap-2"
          onSubmit={async (e) => {
            e.preventDefault();
            setErr(null);
            try {
              await api.devLogin(devEmail);
              nav("/");
            } catch (e) {
              setErr(e instanceof Error ? e.message : "login failed");
            }
          }}
        >
          <input
            className="flex-1 border rounded px-2 py-1 text-sm"
            type="email"
            placeholder="you@example.com"
            value={devEmail}
            onChange={(e) => setDevEmail(e.target.value)}
            required
          />
          <button className="px-3 py-1 rounded bg-slate-700 text-white text-sm">
            Dev login
          </button>
        </form>
        {err ? <p className="text-sm text-red-600 mt-2">{err}</p> : null}
      </div>
    </div>
  );
}
